export const formatTime = (
  dateString?: string,
  locale: string = 'en-US',
): string =>
  dateString
    ? new Intl.DateTimeFormat(locale, { timeStyle: 'short' }).format(
        new Date(dateString),
      )
    : '';
